import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Ora Cacao's "Thriving Tanzania 100% Cacao -
// Organic Ceremonial Chocolate" (p_cso1v004mm), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_oc2: FaireReviewEntity = {
  token: "review_oc2",
  type: "review",
  brandName: "Ora Cacao",
  brandToken: "b_djuc44eyt2",
  productToken: "p_cso1v004mm",
  reviewType: "product",
  reviewerName: "Christine Houtz",
  reviewerLocation: "Shaker Heights, OH, United States",
  stars: 5,
  reviewText:
    "I have a lot of customers who are from Latin America and one of them has cacao and coffee on his property. All of them are so excited and impressed by the cacao I serve. Thank you from me and from them!",
  reviewDate: "May 16, 2024",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T20:50:10.000Z",
    importedBy: "entity-db-cli",
  },
};
